<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    storeModule="SystemCollection"
  />
</template>

<script>
import { DropDownSectionConsts } from 'client/util/Constants';
import { mapActions } from 'vuex';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';
import SystemFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemFilters';

const {
  selectOne,
} = DropDownSectionConsts;

export default {
  name: 'PolicySystemDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data() {
    const dropDownMenuSections = [
      {
        menuLabel: 'device status:',
        menuType: selectOne,
        menuItems: [
          {
            filter: SystemFilters.status(true),
            label: 'active',
            action: () => {
              this.handleDropDownAction(SystemFilters.status(true));
            },
          },
          {
            filter: SystemFilters.status(false),
            label: 'inactive',
            action: () => {
              this.handleDropDownAction(SystemFilters.status(false));
            },
          },
        ],
      },
      {
        menuLabel: 'disk encryption status:',
        menuType: selectOne,
        menuItems: [
          {
            filter: SystemFilters.fde(true),
            label: 'encrypted',
            action: () => {
              this.handleDropDownAction(SystemFilters.fde(true));
            },
          },
          {
            filter: SystemFilters.fde(false),
            label: 'unencrypted',
            action: () => {
              this.handleDropDownAction(SystemFilters.fde(false));
            },
          },
        ],
      },
      {
        menuLabel: 'MDM status:',
        menuType: selectOne,
        menuItems: [
          {
            filter: SystemFilters.mdm('internal'),
            label: 'enrolled',
            action: () => {
              this.handleDropDownAction(SystemFilters.mdm('internal'));
            },
          },
          {
            filter: SystemFilters.mdm(),
            label: 'not enrolled',
            action: () => {
              this.handleDropDownAction(SystemFilters.mdm());
            },
          },
        ],
      },
    ];

    return {
      dropDownMenuSections,
    };
  },

  methods: {
    ...mapActions('SystemCollection', [
      'setFilter',
      'fetchCollection',
    ]),
  },
};
</script>
